import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'displayPhone',
    standalone: true,
})
export class DisplayPhonePipe implements PipeTransform {
    public transform(value: string): string {
        if (value) {
            const prefix: string = value.toString().slice(0, 4).replace(/^0+/, '');

            return '+' + prefix + value.slice(4);
        } else {
            return '';
        }
    }
}
